import { Serializer } from 'jsonapi-serializer';
import { uuidv7 } from 'uuidv7';
import { App } from '../enums/app.enum';

const createSerializer = new Serializer('AppSettings', {
	id: 'id',
	attributes: ['app', 'settings', 'user'],
	keyForAttribute: (attr: string) => attr,
	pluralizeType: false,
	typeForAttribute: (attr: string) => (attr === 'user' ? 'User' : attr),
	user: {
		ref: (record: any) => {
			return record.user?.id;
		},
		included: false,
	},
	transform(record: any) {
		return {
			id: record.id ?? uuidv7(),
			app: record.app,
			settings: JSON.stringify(record.settings),
			user: { id: record.userId },
		};
	},
});

const updateSerializer = new Serializer('AppSettings', {
	attributes: ['settings'],
	keyForAttribute: (attr: string) => attr,
	pluralizeType: false,
	transform(record: any) {
		return {
			id: record.id,
			settings: JSON.stringify(record.settings),
		};
	},
});

export function serializeAppSettingsCreate(app: App, userId: string, settings: unknown) {
	return createSerializer.serialize({
		app,
		settings,
		userId,
	});
}

export function serializeAppSettingsUpdate(id: string, settings: unknown) {
	return updateSerializer.serialize({
		id,
		settings,
	});
}
